module.exports = __webpack_public_path__ + "media/images/instagram-11cca63f28c7629b1426b059d88673cf.svg";